import React from "react";
import About from "./About";
import Features from "./Features";

const AboutPage = () => {
  return (
    <>
      <About />
      <Features />
    </>
  );
};

export default AboutPage;
